<template>
   <wo-breadcrumb label="Breadcrumb" mod-boxed>
      <wo-breadcrumb-item v-for="(route, index) in validRoutes" :key="index">
        <po-route-link :value="route" />
      </wo-breadcrumb-item>
   </wo-breadcrumb>
</template>
<script>

export default {
  name: 'PoRouteBreadcrumb',
  props: {
    routes: Array
  },
  computed: {
    validRoutes () {
      return this.routes || this.$route.matched
    }
  }
}
</script>
